import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-[175px] h-[60px] bg-white border rounded border-gray-500 p-3 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "150",
    height: "33",
    src: "/google-play.png",
    alt: "Disponível no Google Play"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-[175px] h-[60px] bg-white border rounded border-gray-500 p-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "150",
    height: "33",
    src: "/app_store.png",
    alt: "Baixar na App Store"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]

import { computed } from 'vue'
import { ANDROID_STORE_URL, IOS_STORE_URL } from '@/utils/appStoreLinks'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    androidUrl: {},
    iosUrl: {}
  },
  setup(__props: any) {

const props = __props;



const androidHref = computed(() => props.androidUrl || ANDROID_STORE_URL)
const iosHref = computed(() => props.iosUrl || IOS_STORE_URL)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: androidHref.value,
      target: "_blank",
      rel: "noopener noreferrer",
      "data-testid": "google-play-badge-link"
    }, _hoisted_4, 8, _hoisted_2),
    _createElementVNode("a", {
      href: iosHref.value,
      target: "_blank",
      rel: "noopener noreferrer",
      "data-testid": "app-store-badge-link"
    }, _hoisted_7, 8, _hoisted_5)
  ]))
}
}

})